import { createFileRoute, Outlet } from '@tanstack/react-router'
import { FinanceRepositoriesProvider } from '_/features/finance/ui/contexts/finance-repositories-provider'
import { useHouseholdBootstrap } from '_/features/finance/ui/hooks/use-household-bootstrap'
import { ShoppingRepositoriesProvider } from '_/features/shopping/ui/contexts/shopping-repositories-provider'
import type { ReactNode } from 'react'

// Shopping leans on finance for the household, its vendors and its categories,
// and hands a finished trip back as a transaction. The finance provider is
// mounted here for that, not because shopping is part of it.
const BootstrapGate = ({ children }: { children: ReactNode }) => {
	useHouseholdBootstrap()
	return <>{children}</>
}

const ShoppingLayout = () => {
	return (
		<FinanceRepositoriesProvider>
			<ShoppingRepositoriesProvider>
				<BootstrapGate>
					<Outlet />
				</BootstrapGate>
			</ShoppingRepositoriesProvider>
		</FinanceRepositoriesProvider>
	)
}

export const Route = createFileRoute('/_authenticated/shopping')({
	component: ShoppingLayout,
})
